import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-state-reorder',
  templateUrl: './state-reorder.component.html',
  styleUrl: './state-reorder.component.scss'
})
export class StateReorderComponent implements OnInit {
  @Input() public Content: any;
  content:any;
  ActionStatesList: any = [];
  DynamicStatesList: any = [];
  ChangesHappend:boolean=false;

  constructor(
    public modalRef: NgbActiveModal,
    private commonService:CommonService
  ) { }

  ngOnInit(): void {
    
    let statusCodes="1,2,6,7,8,9,99";
    this.ActionStatesList =this.Content.Data.filter((item)=>{
      return (statusCodes.indexOf(item.STATUSCODE) >-1 || (item.RecordStatus=='Inactive' || item.ISCHECKED == false))
    });
    this.DynamicStatesList=this.Content.Data.filter((item)=>{
      return (statusCodes.indexOf(item.STATUSCODE)==-1  && (item.RecordStatus=='Active' && item.ISCHECKED == true))
    });
  
  }

  SaveOrder()
  {
    let FinalOrderedStatesaList=[];
    this.ActionStatesList.forEach((element,index) => {
      if(element.STATUSCODE=="1")
      {
        element.SNO=1;
        FinalOrderedStatesaList.push(element);
      }
      if(element.STATUSCODE=="2")
      {
        element.SNO=2;
        FinalOrderedStatesaList.push(element);
      }
    });
    this.DynamicStatesList.forEach((element,index) => {
      element.SNO=index+3;
      FinalOrderedStatesaList.push(element);
    });
    this.ActionStatesList.forEach((element,index) => {
      if(element.STATUSCODE!="1" && element.STATUSCODE!="2")
      {
        element.SNO=FinalOrderedStatesaList.length+(index+1);
        FinalOrderedStatesaList.push(element);
      }
    });
      this.modalRef.close(FinalOrderedStatesaList);
  }
  Close()
  {
    this.canExit().then(x=>{
      this.modalRef.dismiss();
    });  
  }

  listSorted(event:any){
   this.ChangesHappend=true;
  }

  canExit() {
    if (this.ChangesHappend) {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

}
